import React from 'react'
import moment from 'moment'
import { DcButton, DcInput, PixelFactoryContext } from 'pixel-base'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'

import { processVendorCommission } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'
type MarkAsPaidProps = InferProps<typeof MarkAsPaid.propTypes>

const MarkAsPaid = ({ handleClose, markAsPaid }: MarkAsPaidProps) => {
  const [data, setData] = React.useState({
    date: '',
    notes: '',
    payment_id: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const updateProcessVendorCommission = () => {
    showPageLoader()
    const setting = {
      date: data.date,
      notes: data.notes,
      payment_id: data.payment_id,
    }
    processVendorCommission(setting, markAsPaid.vendor_id).subscribe(
      (res: any) => {
        if (!res.response.error) {
          showSuccess('Successfully Paid')

          handleClose(res.response.data)
          hidePageLoader()
        } else {
          if (res.response.error && res.response.field) {
            setError({
              error: res.response.error,
              field: res.response.field,
            })
          } else {
            showFailure(res.response.error)
          }
          hidePageLoader()
        }
      },
    )
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    updateProcessVendorCommission()
  }

  React.useEffect(() => {
    setData({
      ...data,
      ...markAsPaid,
      date: markAsPaid.pay_date,
      payment_id: markAsPaid.vendor_payment_settlement_id,
    })
  }, [markAsPaid])
  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcInput
            error={
              error.field === 'Name' && error.error !== '' ? error.error : null
            }
            required
            as={'datePicker'}
            name={'Name'}
            placeholder={'Date'}
            value={moment(data.date).format('YYYY-MM-DD 19:14:SS.SSSSSS')}
            onChange={(e) => {
              setData({
                ...data,
                date: moment(e).format('YYYY-MM-DD'),
              })
            }}
          />
        </FormGroup>
        <FormGroup>
          <DcInput
            error={
              error.field === 'notes' && error.error !== '' ? error.error : null
            }
            required
            as={'textarea'}
            name={'notes'}
            placeholder={'Payment Notes'}
            value={data.notes}
            onChange={(e) => setData({ ...data, notes: e.target.value })}
          />
        </FormGroup>
        <FormGroup flexEnd={true}>
          <DcButton type={'submit'}>Pay</DcButton>
        </FormGroup>
      </Form>
    </div>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;

  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

MarkAsPaid.propTypes = {
  handleClose: PropTypes.func.isRequired,
  markAsPaid: PropTypes.shape({
    vendor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pay_date: PropTypes.any,
    vendor_payment_settlement_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }).isRequired,
}

export default MarkAsPaid
